// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/menu/menu.less
// module id = 2703
// module chunks = 0 1